<template>
  <form
    ref="form"
    novalidate
    class="container px-0 d-flex flex-column justify-content-between needs-validation"
    @submit="submit"
  >
    <div class="flex-grow-1">
      <div class="row">
        <BootstrapFormControl
          v-model="modelName"
          name="Penalty Name"
          class="col"
          required
          :error="errorMessages.get('name')"
          :server-error="serverError"
        />
        <BootstrapFormControl
          v-model="modelPercentage"
          name="Percentage"
          class="col"
          required
          :error="errorMessages.get('percentage')"
          :server-error="serverError"
        />
        <BootstrapFormControl
          v-model="modelServiceCredit"
          name="Service Credit"
          class="col"
          required
          :error="errorMessages.get('service_credit')"
          :server-error="serverError"
        />
        <BootstrapSelect
          v-model="modelSlo"
          name="Service Level Objective"
          class="col"
          :options="sloOptions"
          required
          :error="errorMessages.get('slo_id')"
          :server-error="serverError"
        />
      </div>
      <div class="row">
        <BootstrapFormControl
          v-model="modelDescription"
          name="Responsibility Description"
          class="col"
          required
          :error="errorMessages.get('description')"
          :server-error="serverError"
          textarea
        />
      </div>
      <div class="row mt-3">
        <div class="d-flex w-100">
          <BootstrapButton
            name="submit"
            class="me-2"
            type="submit"
            :disabled="loading"
            :loading="loading"
            @click.stop
          >
            Save
          </BootstrapButton>
          <BootstrapButton name="cancel" variant="secondary" @click="router.go(-1)">
            Cancel
          </BootstrapButton>
        </div>
      </div>
    </div>
  </form>
</template>
<script lang="ts" setup>
const props = defineProps<{
  description: string;
  errorMessages: Map<any, any>;
  loading: boolean;
  name: string;
  percentage: number;
  serverError: boolean;
  serviceCredit: number;
  slo: string;
  sloOptions: string[];
}>();

const emit = defineEmits<{
  'update:description': [value: string];
  'update:name': [value: string];
  'update:percentage': [value: number];
  'update:serviceCredit': [value: number];
  'update:slo': [value: string];
  submit: [form: globalThis.Ref<HTMLFormElement | null>];
}>();

const router = useRouter();

// Template ref
const form = ref<HTMLFormElement | null>(null);

// Models
const modelDescription = computed({
  get: () => props.description,
  set: (value) => emit('update:description', value),
});
const modelName = computed({
  get: () => props.name,
  set: (value) => emit('update:name', value),
});
const modelPercentage = computed({
  get: () => String(props.percentage),
  set: (value) => emit('update:percentage', Number(value)),
});
const modelServiceCredit = computed({
  get: () => String(props.serviceCredit),
  set: (value) => emit('update:serviceCredit', Number(value)),
});
const modelSlo = computed({
  get: () => props.slo,
  set: (value) => emit('update:slo', value),
});

// https://getbootstrap.com/docs/4.6/components/forms/?#how-it-works
const submit = async (event: Event) => {
  if (form.value?.checkValidity() === false) {
    event.preventDefault();
    event.stopPropagation();
    form.value.classList.add('was-validated');
  } else {
    event.preventDefault();
    emit('submit', form);
  }
};
</script>
